export const s = {
  header: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  spaceName: {
    fontWeight: 600,
  },
  venueName: {
    fontWeight: 500,
  },
  address: {
    fontWeight: 500,
  },
  costTotal: {
    fontSize: '24px',
    fontWeight: 600,
    color: '#1F1F1F',
  },
  pinIcon: {
    fontSize: '12px',
    marginRight: '6px',
    marginLeft: '6px',
  },
  scollToMap: {
    padding: '0px',
    marginTop: '-4px',
    marginLeft: '10px',
    fontSize: '18px',
    fontWeight: 500,
    color: '#AF231C',
  }
}
